import axios from "axios";
import * as d3 from "d3";
import {format, fw_progressive_1way, responsivefy} from '../functions'
import Sankey from "d3-sankey/src/sankey";
import {sankeyCenter, sankeyJustify, sankeyLinkHorizontal} from "d3-sankey";

export default function (chart, divId, vizName, filterParam, checkbox) {

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)


    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chart.width + chart.margin.left + chart.margin.right)
        .attr("height", chart.height - chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

    var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way);

    var Aligncheckbox = checkbox == true ? sankeyCenter : sankeyJustify;

    // Set the sankey diagram properties
    var sankey = Sankey()
        .nodeWidth(15)
        .nodePadding(10)
        .nodeAlign(Aligncheckbox)
        //.nodeAlign(['left'])
        // .nodeAlign(function (node) {
        //     // you may specify the horizatonal location here
        //     // i.e. if your data structure contain node.horizontalPosition (an integer)
        //     // you can return node.horizontalPosition
        //     return node.depth; //align left
        // })
        // .extent([[1, 1], [chart.width - 1, chart.height - 6]])
        .size([chart.width, chart.height])
        .nodeSort(null);

    var path = sankeyLinkHorizontal();

    console.log(path)

    axios.post(url, filterParam).then(res => {

        let data = res.data

        console.log("sankey", data)
        //set up graph in same style as original example but empty
        var sankeydata = {"nodes": [], "links": []};

        var keys = Object.keys(data[0]); //get the headers for the data
        keys.splice(keys.indexOf('metric1'), 1)//remove the IDs key

        data.forEach(function (d) {
            keys.forEach(function (key, i) {
                if (d[key] != null) {
                    adduniquenodes(d[key]);
                } //add node if not "none"
                var c = 1; //checks next column
                if (d[keys[i + c]] != undefined && d[key] !== null) {
                    while (d[keys[i + c]] === null) {
                        c = c + 1;     //jump to next column if "none" found in the column next
                    }
                    sankeydata.links.push({
                        "source": d[key],
                        "target": d[keys[i + c]],
                        "value": countvalues(key, d[key], keys[i + c], d[keys[i + c]])
                    });
                }
            })
        });

        function adduniquenodes(value) {
            if (sankeydata.nodes.indexOf(value) === -1) {
                sankeydata.nodes.push(value);
            }
        }

        function countvalues(sourcekey, source, targetkey, target) {
            var c = 0;
            data.forEach(function (d) {
                if (d[sourcekey] === source && d[targetkey] === target) {
                    c++;
                }

            });
            return c;
        }

        // loop through each link replacing the text with its index from node
        sankeydata.links.forEach(function (d, i) {
            sankeydata.links[i].source = sankeydata.nodes.indexOf(sankeydata.links[i].source);
            sankeydata.links[i].target = sankeydata.nodes.indexOf(sankeydata.links[i].target);
        });

        //now loop through each nodes to make nodes an array of objects
        // rather than an array of strings
        sankeydata.nodes.forEach(function (d, i) {
            sankeydata.nodes[i] = {"name": d};
        });

        /* sankeydata.nodes(graph.nodes)
               .links(graph.links)
               .layout(32);*/

        var graph = sankey(sankeydata);


        console.log(graph);
        // // add in the links
        let link = svg.append('g')
            //.attr('class', 'links')
            .attr('fill', 'none')
            .attr('stroke', '#000')
            .attr('stroke-opacity', 0.2)
            .selectAll('path');

        let node = svg.append('g')
            // .attr('class', 'nodes')
            .attr('font-size', 10)
            .selectAll('g');

        link = link
            .data(graph.links)
            .enter()
            .append('path')
            .attr('d', path) // d3.sankeyLinkHorizontal()
            .attr('stroke-width', (d) => {
                return Math.max(1, d.width);
            })
            .attr('stroke', (d) => {
                return metric1ColorScale(d.source.name);
            })

        link.append('title')
            .text((d) => {
                return `${d.source.name} → ${d.target.name} -> ${format(d.value)}`;
            });

        node = node
            .data(graph.nodes)
            .enter()
            .append('g');

        node.append('rect')
            .attr('x', (d) => {
                return d.x0;
            })
            .attr('y', (d) => {
                return d.y0;
            })
            .attr('height', (d) => {
                return d.y1 - d.y0;
            })
            .attr('width', (d) => {
                return d.x1 - d.x0;
            })
            .attr('fill', (d) => {
                return metric1ColorScale(d.name.replace(/ .*/, ''));
            })
            .attr('stroke', '#000')


        node.append('text')
            .attr('x', (d) => {
                return d.x0 - 6;
            })
            .attr('y', (d) => {
                return (d.y1 + d.y0) / 2;
            })
            .attr('dy', '0.35em')
            .attr('text-anchor', 'end')
            .text((d) => {
                return d.name;
            })
            .filter((d) => {
                return d.x0 < chart.width / 2;
            })
            .attr('x', (d) => {
                return d.x1 + 6;
            })
            .attr('text-anchor', 'start');

        node.append('title')
            .text((d) => {
                return `${d.name} => ${format(d.value)}`;
            });
    });

}
